"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
class MutateOnMount extends react_1.default.Component {
    componentDidMount() {
        this.props.mutate();
    }
    render() {
        if (typeof this.props.children === 'function') {
            return this.props.children();
        }
        return react_1.default.createElement(react_1.default.Fragment, null, this.props.children);
    }
}
exports.MutateOnMount = MutateOnMount;
//# sourceMappingURL=MutateOnMount.js.map